module.exports = __webpack_public_path__ + "img/boxing-arena.3a12d38a.webp";